import api from "./api";

const BASE_PATH = "/physical-measurements";

// ✅ CREATE new measurement
export const createMeasurement = (studentId: number, data: any) =>
  api.post(`${BASE_PATH}/student/${studentId}`, data);

// ✅ UPDATE existing measurement
export const updateMeasurement = (measurementId: number, data: any) =>
  api.put(`${BASE_PATH}/${measurementId}`, data);

// ✅ GET measurement history
export const getMeasurementsByStudent = (
  studentId: number,
  page: number,
  size: number,
  search?: string
) =>
  api.get(`${BASE_PATH}/student/${studentId}`, {
    params: { page, size, ...(search ? { search } : {}) }
  });

// ✅ GET all measurements
export const getAllMeasurements = (
  page: number,
  size: number,
  search?: string
) =>
  api.get(BASE_PATH, {
    params: { page, size, ...(search ? { search } : {}) }
  });

// ✅ DELETE single measurement
export const deleteMeasurement = (measurementId: number) =>
  api.delete(`${BASE_PATH}/${measurementId}`);

// ✅ BULK DELETE measurements
export const deleteBulkMeasurements = (ids: number[]) =>
  api.delete(`${BASE_PATH}/bulk`, { data: ids });

// ✅ BULK upload
export const bulkUpload = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(`${BASE_PATH}/bulk`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

